import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Fetch categories async thunk
export const fetchCategories = createAsyncThunk(
  "categories/fetchCategories",
  async (BASE_URL) => {
    try {
      const response = await axios.get(`${BASE_URL}/get_cates`);
      console.log(response.data.data)
      return response.data.data;
    } catch (err) {
      console.error(err);
      throw err; 
    }
  }
);

// Create slice
const categorySlice = createSlice({
  name: "categories",
  initialState: { categories: [], isLoading: false, error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCategories.pending, (state) => {
        state.isLoading = true;
        state.error = null; // Reset error on pending
      })
      .addCase(fetchCategories.fulfilled, (state, action) => {
        state.isLoading = false;
        state.categories = action.payload; // Store fetched data
      })
      .addCase(fetchCategories.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message; // Store error message
      });
  },
});

export default categorySlice.reducer;